//  Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import {Injectable} from '@angular/core';
import {BaseService} from './base-service';
import {Observable} from 'rxjs';
import {API_URL} from '../shared/api';
import {EncryptionEvent} from '../types/encryption-events';
import {SortAttr} from '../types/common'
interface EncryptionEventsGetResponse {
    events: EncryptionEvent[];
    count: number;
}

@Injectable({
    providedIn: 'root'
})
export class EncryptionEventService extends BaseService {
    getEncryptionEvents(selectedOrgId: string, limit: number, offset: number = null, searchText: string = null,
                        events: string[] = [],
                        sortAttrs: [SortAttr] = [{ 'sortAttr': 'dttm', 'sortOrder': 'desc' }],
                        scopes: string[] = null,
                        timeLow: number=null): Observable<EncryptionEventsGetResponse> {
        const query = [['limit', limit.toString()]];
        if (!!offset) {
            query.push(['offset', offset.toString()]);
        }
        if (selectedOrgId) {
            query.push(['selectedOrgId', selectedOrgId]);
        }
        if (searchText) {
            query.push(['searchText', searchText])
        }

        if (events && events.length > 0) {
            query.push(['events', JSON.stringify(events)]);
        }

        if (sortAttrs && sortAttrs.length > 0) {
            query.push(['sorts', JSON.stringify(sortAttrs)])
        }

        if ( scopes && scopes.length > 0) {
            query.push(['scopes', JSON.stringify(scopes)])
        }
        if ( timeLow && timeLow > 0 ) {
            query.push(['timeLow', timeLow.toString()])
        }


        const url = this.getUrl(API_URL.ENCRYPTION_EVENTS, query);
        return this.http.get<EncryptionEventsGetResponse>(url);
    }
}
